import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List as MuiList, ListItem as MuiListItem } from '@mui/material';
import { useTranslation } from '@zurich/common/hooks';
import { Link } from '../../components/Link';
import { Typography } from '../../components/Typography';
import { styled } from '../../utils';
export function Footer() {
    const { t } = useTranslation();
    return (_jsx(RootStyled, { children: _jsx(ContainerStyled, { children: _jsxs(NavStyled, { role: "menu", children: [_jsx(MuiListItem, { disableGutters: true, role: "menuitem", children: _jsx(Link, { target: "_blank", color: "secondary", href: t('common:footer.links.impress.link'), children: t('common:footer.links.impress.title') }) }), _jsx(MuiListItem, { disableGutters: true, role: "menuitem", children: _jsx(Link, { target: "_blank", color: "secondary", href: t('common:footer.links.legal_notice.link'), children: t('common:footer.links.legal_notice.title') }) }), _jsx(MuiListItem, { disableGutters: true, role: "menuitem", children: _jsx(Link, { target: "_blank", href: t('common:footer.links.data_protection.link'), children: t('common:footer.links.data_protection.title') }) }), _jsx(MuiListItem, { disableGutters: true, role: "menuitem", children: _jsxs(Typography, { variant: "body1", component: "span", color: "inherit", children: ["\u00A9 ", new Date().getFullYear(), " ", t('common:zurich')] }) })] }) }) }));
}
const RootStyled = styled('footer')(({ theme }) => ({
    backgroundColor: theme.palette.groupPrimary.aliceBlue,
    width: '100%',
}));
const ContainerStyled = styled('div')(({ theme }) => ({
    maxWidth: '1336px',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: theme.spacing(4, 2, 4, 2),
    display: 'grid',
    gridGap: theme.spacing(1.5),
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2, 5, 2, 5),
    },
}));
const NavStyled = styled(MuiList)(({ theme }) => ({
    marginLeft: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    gridColumnGap: theme.spacing(4),
    '& .MuiListItem-root': {
        width: 'auto',
    },
}));
